import { render } from "./LandingTest.vue?vue&type=template&id=1e9d1a59&scoped=true"
import script from "./LandingTest.vue?vue&type=script&lang=js"
export * from "./LandingTest.vue?vue&type=script&lang=js"

import "@/css/landing.scss?vue&type=style&index=0&id=1e9d1a59&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9d1a59"]])

export default __exports__